import { DialogHTMLAttributes, PropsWithChildren } from 'react';

export const PromptDialogSlot = {
  CloseButton: 'CloseButton',
  Header: 'Header',
  Body: 'Body',
  Footer: 'Footer',
} as const;

export type PromptDialogSlot = (typeof PromptDialogSlot)[keyof typeof PromptDialogSlot];

export type PromptDialogProps = PropsWithChildren<
  DialogHTMLAttributes<HTMLDialogElement>
>;

export type PromptProps = PropsWithChildren & {
  className?: string;
  systemPrompt?: boolean;
  extended?: boolean;
};
